<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="six wide field">
        <label>店舗名 / TEL</label>
        <div class="ui action input">
          <input v-model="searchForm.model.q" type="text" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <pagination :pager="pager" :callback="search"></pagination>
    <table class="ui compact selectable table">
      <thead>
        <tr>
          <th class="shop-id">店舗ID</th>
          <th>店舗名</th>
          <th>TEL</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="shop in shops" :key="shop.id">
          <td class="shop-id">{{ shop.id }}</td>
          <td>{{ shop.name }}</td>
          <td>{{ shop.tel }}</td>
          <td class="actions">
            <a class="clickable" :href="shop.auth_url" target="_blank">店舗ページへ</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            searchForm: this.createForm(this.query()),
            pager: this.createPager(15, this.query().offset),
            shops: [],
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model);
            return this.searchForm.get('/groupadmin/api/shops', function(response) {
                this.shops = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        }
    }
};
</script>
